const routes = [
    {
        name: 'listarAssuntosAtendimentos',
        path: 'assuntos',
        alias: 'assuntos/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarAssuntoAtendimento',
        path: 'assuntos/adicionar',
        component: () => import('../views/Adicionar')
    },
    {
        name: 'editarAssuntoAtendimento',
        path: 'assuntos/editar/:id',
        component: () => import('../views/Editar')
    },
    {
        name: 'visualizarAssuntoAtendimento',
        path: 'assuntos/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
   
]
export default routes


